import type { KpiPeriod } from './useKpiPeriod';

type Props = {
  value: KpiPeriod;
  onChange: (v: KpiPeriod) => void;
};

export default function PeriodToggle({ value, onChange }: Props) {
  const opt = (key: KpiPeriod, label: string) => (
    <button
      type="button"
      onClick={() => onChange(key)}
      className={`px-2.5 py-0.5 text-[10.5px] font-semibold tracking-tight rounded-md transition-colors ${
        value === key
          ? 'bg-cream-50 text-ink-900 shadow-card-sm'
          : 'text-ink-500 hover:text-ink-900'
      }`}
    >
      {label}
    </button>
  );
  return (
    <div className="inline-flex gap-0.5 bg-cream-200 p-0.5 rounded-lg">
      {opt('total', 'Total')}
      {opt('30d', '30d')}
    </div>
  );
}
